import React from "react";
import * as Serv from "../style/tjanster-style";
import * as Lib from "../style/lib";
import starSkill from "../../assets/at-details/starSkill.svg";
import arrowservice from "../../assets/at-details/longArrow.svg";
//<Serv.LongArrow src={arrowservice} alt="" aria-hidden="true" />
//	<Serv.Divider />

export const TheServices: React.FC = () => {
	return (
		<Serv.ServiceOuterContainer id="tjanster">

			<Serv.ServiceContainer>
				<Serv.ServiceIntroContainer>
					<Serv.ServiceHead2>Vi kan det du behöver</Serv.ServiceHead2>
					<Lib.MainParagraph>
						AndTech grundades med övertygelsen om att det är teknik som driver
						bolag framåt. Vi bygger på långvariga samarbeten och strävar efter
						att skapa något unikt tillsammans.
						<br />
						<br />
						Genom att kombinera dina affärsmål med användarnas behov, skapar vi
						lösningar som både håller över tid och ger ett verkligt värde.
						
					</Lib.MainParagraph>
					<Serv.LongArrow src={arrowservice} alt="" aria-hidden="true" />
				</Serv.ServiceIntroContainer>

			<Serv.Divider />

				<div>
					<Serv.ServiceItemWeb
						to="/webbutveckling"
						role="link"
						aria-label="Läs mer om webbutveckling">

						<Serv.ServiceTitleWeb>Webbutveckling</Serv.ServiceTitleWeb>

						<Lib.MainParagraph>
							Vi skapar webblösningar där tillgänglighet och
							prestanda är en självklar del. Från design och utveckling till
							lansering och underhåll ser vi till att din webbplats är snabb,
							lätt att använda och håller över tid.
						</Lib.MainParagraph>

						<Serv.SkillDetails>
							<Serv.SkillIcon src={starSkill} alt="" aria-hidden="true" />
							<Serv.SkillsList>
								<li>UX/UI</li>
								<li>SEO</li>
								<li>Webflow</li>
								<li>Hosting & förvaltning</li>
							</Serv.SkillsList>
						</Serv.SkillDetails>
					</Serv.ServiceItemWeb>

					<Serv.DividerHori />

					<Serv.ServiceItemPartner
						to="/at-partner"
						role="link"
						aria-label="Läs mer om Andtech Partner">
						<Serv.ServiceTitlePartner>Andtech Partner</Serv.ServiceTitlePartner>
						<Lib.MainParagraph>
							Andtech Partner är ett flexibelt IT-abonnemang som ger er ett erfaret utvecklingsteam – utan att anställa. Vi hjälper er digitalisera, integrera och fatta smarta tekniska beslut.
						</Lib.MainParagraph>

						<Serv.SkillDetails>
							<Serv.SkillIcon src={starSkill} alt="" aria-hidden="true" />
							<Serv.SkillsList>
								<li>Support</li>
								<li>Utveckling</li>
								<li>Projektledning</li>
							</Serv.SkillsList>
						</Serv.SkillDetails>
					</Serv.ServiceItemPartner>

					<Serv.DividerHori />

					<Serv.ServiceItemConsult
						to="/konsulter"
						role="link"
						aria-label="Läs mer om våra konsulter">

						<Serv.ServiceTitleConsult>Konsulter</Serv.ServiceTitleConsult>

						<Lib.MainParagraph>
							Engagerade konsulter för dina utmaningar. Med skräddarsydda lösningar
							som matchar era behov ser vi till att rätt kompetens landar på rätt plats.
						</Lib.MainParagraph>

						<Serv.SkillDetails>
							<Serv.SkillIcon src={starSkill} alt="" aria-hidden="true" />
							<Serv.SkillsList>
								<li>DevOps</li>
								<li>Systemutveckling</li>
								<li>Arkitektur</li>
								<li>Frontendutveckling</li>
								<li>Backend & API-lösningar</li>
							</Serv.SkillsList>
						</Serv.SkillDetails>
					</Serv.ServiceItemConsult>
				</div>
			</Serv.ServiceContainer>
		</Serv.ServiceOuterContainer>
	);
};
